/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ExtendedSearchStravaTab_eventDates$ref: FragmentReference;
declare export opaque type ExtendedSearchStravaTab_eventDates$fragmentType: ExtendedSearchStravaTab_eventDates$ref;
export type ExtendedSearchStravaTab_eventDates = {|
  +beginsAt: ?any,
  +endsAt: ?any,
  +$refType: ExtendedSearchStravaTab_eventDates$ref,
|};
export type ExtendedSearchStravaTab_eventDates$data = ExtendedSearchStravaTab_eventDates;
export type ExtendedSearchStravaTab_eventDates$key = {
  +$data?: ExtendedSearchStravaTab_eventDates$data,
  +$fragmentRefs: ExtendedSearchStravaTab_eventDates$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ExtendedSearchStravaTab_eventDates",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "beginsAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endsAt",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b297d1de33d8484ab20c4ec2d07bb502';

module.exports = node;
